import { gql } from "@stadium/services/apollo-client";

export const fetchMenu = gql`
  query Menu(
    $storeNumber: String!
    $country: String!
    $location: String!
    $intent: String!
    $globalZone: Boolean
    $includeDisabledTaxons: Boolean
    $includeDeactivatedProducts: Boolean
    $includeLockedSp: Boolean
    $forPriceless: Boolean
    $minPrice: Float
    $maxPrice: Float
    $menuItemAttachmentHeight: String
    $menuItemAttachmentWidth: String
    $onlyEnabledTaxons: Boolean = true
    $menuItemsCountry: String
  ) {
    menu(
      storeNumber: $storeNumber
      country: $country
      location: $location
      globalZone: $globalZone
    ) {
      id
      name
      menuItems(
        storeNumber: $storeNumber
        country: $menuItemsCountry
        intent: $intent
        globalZone: $globalZone
        includeDisabledTaxons: $includeDisabledTaxons
        includeDeactivatedProducts: $includeDeactivatedProducts
        includeLockedSp: $includeLockedSp
        forPriceless: $forPriceless
        minPrice: $minPrice
        maxPrice: $maxPrice
        height: $menuItemAttachmentHeight
        width: $menuItemAttachmentWidth
      ) {
        id
        attachment(height: $menuItemAttachmentHeight, width: $menuItemAttachmentWidth)
        topContent
        bottomContent
        productsImage
        themeLandscapeImage
        themePortraitImage
        themeCollection
        banner
        mobileBanner
        code
        name
        depth
        parentId
        lft
        swagBannerAddable
        menuItemEnabled(number: $storeNumber)
        linkedTaxonResources: linkedResources(
          onlyEnabledTaxons: $onlyEnabledTaxons
          number: $storeNumber
        ) {
          ... on Taxon {
            id
            forSwag
          }
        }
      }
    }
  }
`;
